<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <form [formGroup]="confirmForm">
    <ion-label class="title"> {{'ACCOUNT.phoneNumber.verify.title' | translate}} </ion-label>
    <ion-label [innerHtml]="'ACCOUNT.phoneNumber.verify.p' | translate: { phoneNumber: customer?.unverified_phone }"></ion-label>
    <app-otp-code [code]="code" (update)="otpCodeUpdate($event)"></app-otp-code>
  </form>
  <a class="resend-code" (click)="sendCode()">{{ 'ACCOUNT.phoneNumber.verify.resendCode' | translate }}</a>
  <p class="contact">
    {{ 'ACCOUNT.phoneNumber.verify.note' | translate }}
    <a (click)="redirectToSupport()">{{ 'profile.personaldetails.editaddress.link' | translate }}</a>.
  </p>
</ion-content>
